const appRoutes = {
  user: "/user",
  users: "/users",
  agents: "/agents",
  audit: "/audit",
  notFound: "/404",
  error: "/error",
  unauthorised: "/unauthorised",
  loggedOut: "/loggedout",
};

export default appRoutes;
